import(/* webpackMode: "eager", webpackExports: ["TransitionLink"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDL-Website\\src\\components\\TransitionLink.tsx");
